import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import './Login.css'

import { auth }  from './firebase'

function Login() {
const history = useHistory()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

 const signInbutton =(e)=>{
  e.preventDefault()
  auth.signInWithEmailAndPassword(email, password).then(auth=>{
      history.push('/')
  }).catch(err=> alert(err.message))

 }

 const registerbutton =()=>{ 
            history.push('/register')
  
   }


  return (
    <div className='login' >
        <Link to='/'>
         <img className="login_logo"src='https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/1024px-Amazon_logo.svg.png' 
            alt=''    />
            </Link>
       <div className='login_container' >
           <h1>Sign-in</h1>
           <form>
               <h4>E-mail</h4>
               <input type="email"  value={email} onChange ={e => setEmail(e.target.value)} required />
               <h4>Password</h4>
               <input type="password" value={password} onChange ={e => setPassword(e.target.value)} required/>
               <button className='signinButton' onClick={signInbutton}  >Sign In</button>
           </form>

           <p>
           By signing-in you agree to the AMAZON CLONE Conditions of Use & Sale. Please
         see our Privacy Notice, our Cookies Notice and our Interest-Based Ads Notice.
           </p>
           <br/>
         <hr/>
         <p style={{textAlign:"center"}} >------------New to Amazone-----------<br/></p>
           <button className='login_registerButton' onClick={registerbutton} >Create your Amazone Account</button>
       </div>
       <hr/>
    </div>
  )
}

export default Login